var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.467 8H17.533C12.2765 8 8 12.2765 8 17.533V30.467C8 35.7235 12.2765 40 17.533 40H30.467C35.7235 40 40 35.7235 40 30.467V17.533C39.9999 12.2765 35.7235 8 30.467 8ZM36.7808 30.467C36.7808 33.954 33.954 36.7808 30.467 36.7808H17.533C14.046 36.7808 11.2192 33.954 11.2192 30.467V17.533C11.2192 14.0459 14.046 11.2192 17.533 11.2192H30.467C33.954 11.2192 36.7808 14.0459 36.7808 17.533V30.467Z",
    fill: "url(#paint0_linear_3_510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.7236C19.4364 15.7236 15.7237 19.4364 15.7237 23.9999C15.7237 28.5634 19.4364 32.2763 24 32.2763C28.5636 32.2763 32.2763 28.5635 32.2763 23.9999C32.2763 19.4363 28.5636 15.7236 24 15.7236ZM24 29.0571C21.207 29.0571 18.9429 26.793 18.9429 24C18.9429 21.207 21.2071 18.9428 24 18.9428C26.793 18.9428 29.0571 21.207 29.0571 24C29.0571 26.7929 26.7929 29.0571 24 29.0571Z",
    fill: "url(#paint1_linear_3_510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2924 17.7691C33.3876 17.7691 34.2755 16.8812 34.2755 15.7859C34.2755 14.6906 33.3876 13.8027 32.2924 13.8027C31.1971 13.8027 30.3092 14.6906 30.3092 15.7859C30.3092 16.8812 31.1971 17.7691 32.2924 17.7691Z",
    fill: "url(#paint2_linear_3_510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_510",
    x1: 24,
    y1: 39.9069,
    x2: 24,
    y2: 8.24855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_510",
    x1: 24,
    y1: 39.9068,
    x2: 24,
    y2: 8.24852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_510",
    x1: 32.2924,
    y1: 39.907,
    x2: 32.2924,
    y2: 8.24867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColor);
export default __webpack_public_path__ + "static/media/instagramColor.801a68beb32e34817a07888145978593.svg";
export { ForwardRef as ReactComponent };